import React from 'react'
import { Widget } from 'features/types'
import { getLabel } from 'utils/widgetTypeUtil'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { AudienceCrosstabWidget as AudienceCrosstabWidgetType } from 'schemas/AudienceCrosstabWidgetSchema'
import CrosstabTopicInaccessibleGuard from '../share/guards/CrosstabTopicInaccessibleGuard'
import CrosstabRowColumnNotSelectedGuard from '../share/guards/CrosstabRowColumnNotSelectedGuard'
import {
  WidgetLoadingGuard,
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  ThemeInaccessibleGuard
} from '../../share/guards'
import RunSearchEffect from '../share/RunSearchEffect'
import CrosstabOverComplexityGuard from '../share/guards/CrosstabOverComplexityGuard'
import CrosstabWidget from '../share/Crosstab'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/hooks/useSelectedInsights'

const AudienceCrosstabWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceCrosstabWidgetType>(widgetId)

  const {
    isModalOpen,
    setIsModalOpen,
    selection,
    countType,
    detailSetting,
    handleHeatmapClick,
    handleBarClick,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <CrosstabTopicInaccessibleGuard widgetId={widgetId}>
        <CrosstabRowColumnNotSelectedGuard widgetId={widgetId}>
          <CrosstabOverComplexityGuard widgetId={widgetId}>
            <RunSearchEffect widgetId={widgetId} isAudienceQuery>
              <WidgetLoadingGuard widgetId={widgetId}>
                <TopicInaccessibleGuard widgetId={widgetId}>
                  <TopicIndexNotReadyGuard widgetId={widgetId}>
                    <ThemeInaccessibleGuard widgetId={widgetId}>
                      <CrosstabWidget
                        widgetId={widgetId}
                        isAudienceQuery
                        onHeatmapClick={handleHeatmapClick}
                        onBarClick={handleBarClick}
                        enableHeatmapTooltip={!isModalOpen}
                      />
                    </ThemeInaccessibleGuard>
                  </TopicIndexNotReadyGuard>
                </TopicInaccessibleGuard>
              </WidgetLoadingGuard>
            </RunSearchEffect>
          </CrosstabOverComplexityGuard>
        </CrosstabRowColumnNotSelectedGuard>
      </CrosstabTopicInaccessibleGuard>
      <WidgetLoadingGuard widgetId={widgetId}>
        <InsightModal
          widgetId={widgetId}
          isAudienceQuery
          widgetSettingWithSelection={widgetSettingWithSelection}
          open={isModalOpen}
          title={widgetSetting?.name || getLabel(widgetSetting?.type)}
          countType={countType}
          selection={selection}
          onClose={() => {
            setIsModalOpen(false)
          }}
          detailSetting={detailSetting}
        />
      </WidgetLoadingGuard>
    </UnexpectedErrorBoundary>
  )
}
export default AudienceCrosstabWidget
